import React, { useState } from 'react'
import dayjs from 'dayjs'
import CalendarDatePicker from 'pages/todo/components/DatePicker'

import Section from '../Section'

import dateIcon from 'assets/images/contacts/Editor/editor-date-20.svg'
import { useTranslation } from 'react-i18next'

interface DatesProps {
  editData: any
  onFieldChange: (propName: string, index: number, value: any) => void
  onLabelChange: (propName: string, index: number, label: string) => void
  onAddItem: (propName: string, label: string) => void
  onDelete: (propName: string, index: number) => void
}

const Dates = ({ editData, onFieldChange, onLabelChange, onAddItem, onDelete }: DatesProps) => {
  const { t } = useTranslation()

  // const [labelList, setLabelList] = useState(
  //   editData.isPersonal
  //     ? [
  //         { key: 'birthday', label: t('contact.property.birthday') },
  //         { key: 'anniversary', label: t('contact.property.anniversary') },
  //       ]
  //     : [
  //         { key: 'birthday', label: t('contact.property.birthday') },
  //         { key: 'anniversary', label: t('contact.property.anniversary') },
  //         { key: 'other', label: t('contact.property.other') },
  //         { key: '', label: t('contact.property.none') },
  //         { key: 'custom', label: t('contact.property.custom') },
  //       ],
  // )

  const labelList = editData.isPersonal
    ? [
        { key: 'birthday', label: t('contact.property.birthday') },
        { key: 'anniversary', label: t('contact.property.anniversary') },
      ]
    : [
        { key: 'birthday', label: t('contact.property.birthday') },
        { key: 'anniversary', label: t('contact.property.anniversary') },
        { key: 'other', label: t('contact.property.other') },
        { key: '', label: t('contact.property.none') },
        { key: 'custom', label: t('contact.property.custom') },
      ]

  const [datePickerOpenIndex, setDatePickerOpenIndex] = useState<number | null>(null)

  const getDropDownInfoList = (label: string) => {
    if (label === 'birthday') {
      return [
        { key: 'birthday', label: t('contact.property.birthday') },
        { key: 'anniversary', label: t('contact.property.anniversary') },
      ]
    } else {
      const hasBirthday = editData.dates.some((date: any) => {
        if (date.type === 'birthday') {
          return true
        }
        return false
      })
      // Master and anniversary
      if (hasBirthday) {
        return [{ key: 'anniversary', label: t('contact.property.anniversary') }]
      } else {
        return [
          { key: 'birthday', label: t('contact.property.birthday') },
          { key: 'anniversary', label: t('contact.property.anniversary') },
        ]
      }
    }
  }

  return (
    <Section
      editData={editData}
      propName="dates"
      labelList={labelList}
      getDropDownInfoList={editData.isPersonal ? getDropDownInfoList : null}
      icon={dateIcon}
      addButtonLabel={t('contact.menu.addDate')}
      onFieldChange={onFieldChange}
      onLabelChange={onLabelChange}
      onAddItem={onAddItem}
      onDelete={onDelete}
      canDelete={(_) => true}
      inputFieldsRender={(index: number) => {
        const data = editData.dates[index]
        return (
          <div key={index} style={{ position: 'relative', width: '100%' }}>
            <button
              style={{
                border: 'none',
                padding: '0',
                width: '100%',
                background: 'transparent',
                textAlign: 'left',
                cursor: 'pointer',
                fontSize: '14px',
                color: '#333',
              }}
              onClick={() => setDatePickerOpenIndex(datePickerOpenIndex === index ? null : index)}
            >
              {dayjs(data.value).format('YYYY-MM-DD')}
            </button>
            {datePickerOpenIndex === index && (
              <div
                style={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: 'rgba(0, 0, 0, 50%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 9999,
                }}
                onClick={() => setDatePickerOpenIndex(null)}
              >
                <div
                  onClick={(e) => e.stopPropagation()}
                  style={{
                    background: 'white',
                    borderRadius: '8px',
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 15%)',
                  }}
                >
                  <CalendarDatePicker
                    value={dayjs(data.value).toDate()}
                    onChange={(date: Date) => {
                      onFieldChange('dates', index, dayjs(date).format('YYYY-MM-DD').toString())
                      setDatePickerOpenIndex(null)
                    }}
                    onClose={() => setDatePickerOpenIndex(null)}
                  />
                </div>
              </div>
            )}
          </div>
        )
      }}
    />
  )
}
export default Dates
